const NBSP = " ";

// Brand lockups that must never be split across a line break.
const LOCKUPS = [
  /\b(PERCORSO)\s+(ALPS)\b/g,
  /\b(Percorso)\s+(ALPS)\b/g,
  /\b(percorso)\s+(ALPS)\b/g,
  /\b(METODO)\s+(ALPS)\b/g,
  /\b(Metodo)\s+(ALPS)\b/g,
  /\b(metodo)\s+(ALPS)\b/g,
];

/**
 * Purely presentational typesetting: swaps the space inside a brand lockup for
 * a non-breaking space so "Percorso ALPS" always sets as one unit. The
 * characters are unchanged — only the break opportunities are.
 * Safe to use on copy of any length.
 */
export const setText = (value) => {
  if (typeof value !== "string" || value.length === 0) return value;
  let out = value;
  for (const pattern of LOCKUPS) out = out.replace(pattern, `$1${NBSP}$2`);
  return out;
};

/**
 * Heading-only typesetting: lockups plus widow control on the FINAL word, so a
 * heading never ends with a single word stranded on its own line.
 *
 * Deliberately NOT gluing every short word mid-string — at 320px that pushes
 * long words onto lines of their own, which is the very problem widow control
 * exists to prevent.
 */
export const setHeading = (value) => {
  if (typeof value !== "string" || value.length === 0) return value;
  const out = setText(value);
  const lastSpace = out.trimEnd().lastIndexOf(" ");
  if (lastSpace === -1) return out;
  return out.slice(0, lastSpace) + NBSP + out.slice(lastSpace + 1);
};

export default setText;
